import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/brandSlice";
import brandApis from "src/api/brand";
import { common } from "src/types";
import { constants } from "src/constants/common";

// ✅ Create Brand Saga
function* CreateBrandSaga({
  payload,
}: ReturnType<typeof actions.createBrandRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      brandApis.createBrand,
      payload
    );
    yield put(actions.createBrandSuccess(response));
  } catch (error) {
    yield put(
      actions.createBrandError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Brand List Saga
function* GetBrandListSaga({
  payload,
}: ReturnType<typeof actions.getBrandListRequest> & {
  payload: {
    page?: number;
    limit: number;
    search?: string;
    status?: "active" | "inactive";
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      brandApis.getBrandList,
      payload
    );
    yield put(actions.getBrandListSuccess(response));
  } catch (error) {
    yield put(
      actions.getBrandListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Edit Brand Saga
function* EditBrandSaga({
  payload,
}: ReturnType<typeof actions.editBrandRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      brandApis.editBrand,
      payload
    );
    yield put(actions.editBrandSuccess(response));
  } catch (error) {
    yield put(
      actions.editBrandError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Brand Saga
function* DeleteBrandSaga({
  payload,
}: ReturnType<typeof actions.deleteBrandRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      brandApis.deleteBrand,
      payload
    );
    yield put(actions.deleteBrandSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteBrandError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* brandSaga() {
  yield all([
    takeEvery(actions.createBrandRequest, CreateBrandSaga),
    takeEvery(actions.getBrandListRequest, GetBrandListSaga),
    takeEvery(actions.editBrandRequest, EditBrandSaga),
    takeEvery(actions.deleteBrandRequest, DeleteBrandSaga),
  ]);
}
